import { showToast } from "./toast.js";
import { restoreMediaItem, updateMediaItem } from "../db/media.js";
import { navigate } from "../main.js";

// Undo toasts (roadmap #19). A delete keeps the record in memory for the toast's
// lifetime; Undo puts it back exactly (same id) and reopens it.
export function offerUndoDelete(mediaType, record, { reopenRoute = null } = {}) {
	showToast(`Deleted “${record.title ?? "item"}”`, {
		actionLabel: "Undo",
		durationMs: 7000,
		onAction: async () => {
			try {
				await restoreMediaItem(mediaType, record);
				if (reopenRoute) navigate(reopenRoute);
				showToast("Restored.");
			} catch (err) {
				showToast(err?.message ?? "Could not restore.");
			}
		},
	});
}

// Undo for a batch of field changes: `changes` = [{ mediaType, id, before }]
// where `before` holds the previous values of the patched fields.
export function offerUndoChanges(message, changes, { onDone } = {}) {
	showToast(message, {
		actionLabel: "Undo",
		durationMs: 7000,
		onAction: async () => {
			for (const c of changes) {
				try {
					await updateMediaItem(c.mediaType, c.id, c.before);
				} catch {
					// item gone meanwhile — nothing to put back
				}
			}
			onDone?.();
			showToast("Undone.");
		},
	});
}
